<div class="modal-header bg-head py-2">
  <h6 class="modal-title"> Assign Study Material</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>

<div class="modal-body m-body pt-0">
  <div class="row assign-studmaterial" style="height: 75vh !important; overflow: auto">
    <form [formGroup]="AddStudyMaterialform" class="col-md-12">
      <div formArrayName="StudyMaterials">
        <div
          *ngFor="let studyMaterial of getStudyMaterialsArray()?.controls; let studyMaterialIndex = index"
          [formGroupName]="studyMaterialIndex"
          class="mb-4"
        >
        <div class="row bg-head-study my-2">
          <div class="d-flex justify-content-between align-items-center">
          <h4 class=" headertext-color">Study Material: <span class="number-style">{{StudyMaterials[studyMaterialIndex]?.Study_Material_Name }}: {{StudyMaterials[studyMaterialIndex]?.Study_Material_Id}}</span></h4>
          <span>
            <i class="fa fa-pencil-square-o fs-4 text-white"  (click)="EditStudyMaterial(studyMaterialIndex)"></i>
          </span>
        </div>
        </div>
          <!-- Row for each study material -->
          <div class="row">
            <!-- Column 1 -->
            <div class="col-md-5">
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 label-red">*</div>
                      <div class="p-0">Study Material Type</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <select
                      formControlName="Study_Material_Type_Code"
                      class="form-control form-control-sm"
                    >
                      <option *ngFor="let s of getmaterial" [value]="s.Code">
                        {{ s.Description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 label-red">*</div>
                      <div class="p-0">Study Material Level</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <select
                      formControlName="Study_Material_Level_Type"
                      class="form-control form-control-sm"
                    >
                      <option *ngFor="let s of getmateriallevel" [value]="s.Code">
                        {{ s.Description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 label-red">*</div>
                      <div class="p-0">Study Material Name</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <input
                      type="text"
                      formControlName="Study_Material_Name"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">Study Material Display Name</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <input
                      type="text"
                      formControlName="Display_Name"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 label-red">*</div>
                      <div class="p-0">Study Material Type</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <select
                      formControlName="Study_Material_Type_Code"
                      class="form-control form-control-sm"
                    >
                      <option *ngFor="let s of getmaterial" [value]="s.Code">
                        {{ s.Description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column 2 -->
            <div class="col-md-3">
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-5 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">Version Number</div>
                    </div>
                  </div>
                  <div class="col-7 pl-2">
                    <select
                      formControlName="Version_Number"
                      class="form-control form-control-sm w-25"
                    >
                      <option *ngFor="let version of versionOptions" [value]="version">
                        {{ version }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-5 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 label-red">*</div>
                      <div class="p-0">Difficulty Level</div>
                    </div>
                  </div>
                  <div class="col-7 pl-2">
                    <select
                      formControlName="Study_Material_Difficulty_Level_Type"
                      class="form-control form-control-sm"
                    >
                      <option
                        *ngFor="let s of courseDifficultyType"
                        [value]="s.Code"
                      >
                        {{ s.Description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-5 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 text-end">Free Resource?</div>
                    </div>
                  </div>
                  <div class="col-7 pl-2">
                    <input
                      type="checkbox"
                      formControlName="Free_Resource_Ind"
                      class="mt-2"

                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-5 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 text-end">Primary Study Material</div>
                    </div>
                  </div>
                  <div class="col-7 pl-2">
                    <input
                      type="checkbox"
                      formControlName="PrimaryStudyMaterialInd"
                      class="mt-2"

                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-5 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0 text-end">Reference Study Material</div>
                    </div>
                  </div>
                  <div class="col-7 pl-2">
                    <input
                      type="checkbox"
                      formControlName="ReferenceStudyMaterialInd"
                      class="mt-2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Column 3 -->
            <div class="col-md-4">
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0"></div>
                    </div>
                  </div>
                  <div class="col-6 pl-2">

                <div class="d-flex justify-content-start align-items-center ">

                <button
                type="button"
                class="btn btn-sm bg-light border"
                style="height: 100px;width:100%"
                >
                  {{ shortenString(studyMaterial.get('File_Name')?.value) || 'No File Selected' }}
                </button>

                <img
                [src]="'/assets/images/pdf_default.PNG'"
                alt=""
                width="100"
                height="100"
              />
            <div class="d-flex">
              <i
              *ngIf="studyMaterial.get('File_Object_Id')?.value"
              class="fa fa-file-pdf-o ms-2  pointer-cursor"
              (click)="onPreview(studyMaterial,studyMaterialIndex)"
              ></i>
            </div>
            </div>
                    <!-- <input
                      type="file"
                      [disabled]="true"
                      formControlName="FileUpload"
                      class="form-control form-control-sm"
                    /> -->
                  </div>
                  <div class="col-2">

                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">File Object Id</div>
                    </div>
                  </div>
                  <div class="col-6 pl-2 text-right">

                    <input
                      type="text"
                      maxlength="100"
                      class="form-control form-control-sm input-txt-url"
                      formControlName="File_Object_Id"
                      readonly
                    />

                  </div>
                  <div class="col-2">

                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">File Location</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2 text-right">
                    <div class="d-flex  gap-2">
                      <textarea
                      rows="5"
                      maxlength="100"
                      class="form-control form-control-sm w-75"
                      formControlName="File_Location_Name"
                    ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">Study Material Url</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2 text-right">
                    <div class="d-flex  gap-2">
                      <textarea
                      rows="2"
                      maxlength="100"
                      class="form-control form-control-sm w-75"
                      formControlName="Study_Material_Url"
                    ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">Number of Pages</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <input
                      type="number"
                      formControlName="NumberOfPages"
                      class="form-control form-control-sm w-25"
                      appNumericInput
                      [max]="9999"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row pt-1">
                  <div class="col-4 text-right pr-0 pt-1 pl-0">
                    <div class="d-flex flex-row-reverse">
                      <div class="p-0">Duration In Minutes</div>
                    </div>
                  </div>
                  <div class="col-8 pl-2">
                    <input
                      type="number"
                      appNumericInput
                      formControlName="Duration_In_Minutes"
                      class="form-control form-control-sm text-end w-25 "
                      [max]="9999"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Column 4 -->
            <div class="col-md-12">
              <div class="row pt-2">
                <div class="col-1 text-right pr-0 pt-1 pl-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0">Description</div>
                  </div>
                </div>
                <div class="col-7">
                  <textarea
                    formControlName="Description_Text"
                    class="form-control"
                    rows="5"
                  ></textarea>
                  <label class="form-check-label maxlength">
                    Characters {{ Descriptionvaluelength[studyMaterialIndex] }}/
                    {{ DescriptionMaxlength }}
                  </label>
                </div>
                <div class="col-4">
                  <div class="d-flex justify-content-center h-100 align-items-md-end py-md-2">
                    <!-- <div class="px-1" *ngIf="AddStudyMaterialflag">
                      <button
                        type="button"
                        (click)="clickpreviewbutton()"
                        class="btn btn-sm bg-light border"
                      >
                        Preview
                      </button>
                    </div> -->

                    <div class="px-1">
                      <!-- <button
                        type="button"
                        (click)="onPreview(studyMaterial,studyMaterialIndex)"
                        class="btn btn-sm bg-light border"
                      >
                        Preview
                      </button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class=" row bg-head">
            <h4 class="my-1">Applicable Course Type</h4>
          </div>
          <div class="col-12 mt-4">

            <div formArrayName="Course_Category_Type" class="d-flex flex-wrap gap-3">
              <div *ngFor="let ccType of getCourseCategoryControls(studyMaterialIndex)?.controls; let j = index" [formGroupName]="j">
                <input type="checkbox" formControlName="SelectedInd" (change)="onCourseCategoryTypeChange($event,ccType,studyMaterialIndex)" />
                {{ ccType.value.CourseCategoryTypeName }}
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-12 bg-head">
              <h4>Applicable Courses</h4>
            </div>
          </div>

          <ng-container *ngFor="let item of courseCategoryList">
            <div class="row my-3" *ngIf="isActivated(item.Code,studyMaterialIndex)">
              <div class="col-12">
                <div class="d-flex align-items-baseline gap-3">
                  <h4>{{ item.Description }}</h4>
                  <i class="fa fa-plus" (click)="addApplicableExamList({ type: item.Code }, studyMaterialIndex)"></i>
                </div>
              </div>
              <div class="col-12">
                <div class="row px-3" *ngIf="CheckIfCourseType(studyMaterialIndex,item.Code)">
                  <div class="col-md-3 col-lg-2 col-xxl-2 px-1">
                    <span class="position-relative">
                      Exam Agency
                      <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                    </span>
                  </div>
                  <div class="col-md-3 col-lg-2 col-xxl-2 px-0">
                    <span class="position-relative">Course Name
                      <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                    </span>
                  </div>
                  <div class="col-md-3 col-lg-2 col-xxl-1 px-0">
                    <span class="position-relative">
                       Year / Month
                      <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                    </span>
                  </div>
                  <div class="col-md-3 col-lg-6 col-xxl-7 px-0">
                    <div class="row">
                      <div
                        class="col-2 col-xxl-2 text-center px-0"
                        *ngFor="let plan of COURSE_PLAN_TYPE"
                      >
                        {{ plan.Description }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Applicable Exam List -->

                <div formArrayName="Applicable_Exam_List">
                <ng-container
                *ngFor="let appExam of getApplicableExamListForStudyMaterial(studyMaterialIndex)?.controls; let examIndex = index"
                >
                <ng-container *ngIf="appExam.get('deleteInd')?.value === 'N'">
                  <div
                    [formGroupName]="examIndex"
                    class="row"
                  >
                    <div class="row mt-2" *ngIf="appExam.value.type === item.Code && CheckIfAnySelectedCoursePlan(appExam.value,studyMaterialIndex)">
                    <!-- Exam Agency -->
                    <div class="col-md-2">
                      <select
                        class="form-control"
                        formControlName="examAgency"
                        (change)="fetchCourseList(appExam , appExam.value.type)"
                      >
                        <option [value]="null" hidden >Select Agency</option>
                        <option
                          *ngFor="let agency of appExam.value.examAgencyList"
                          [value]="agency.Code"
                        >
                          {{ agency.Description }}
                        </option>
                      </select>
                    </div>

                    <!-- Course -->
                    <div class="col-md-2 px-0">
                      <select
                        class="form-control"
                        formControlName="courseId"
                        (change)="fetchCourseYears(appExam, appExam.value.type)"
                      >
                        <option [value]="null" hidden >Select Course</option>
                        <option
                          *ngFor="let course of appExam.value.courseList"
                          [value]="course.Code"
                        >
                          {{ course.Description }}
                        </option>
                      </select>
                    </div>

                    <!-- Year -->
                    <div class="col-md-1">
                      <select class="form-control"
                       formControlName="examYear"
                       (change)="getCoursePlan(studyMaterialIndex,examIndex)"
                       >
                        <option [value]="null" hidden>Select Year</option>
                        <option
                          *ngFor="let year of appExam.value.courseYear"
                          [value]="year.Code"
                        >
                          {{ year.Description }}
                        </option>
                      </select>
                    </div>

                    <!-- Course Plans -->
                    <div class="col-md-7">

                      <div class="row">
                        <div
                          *ngFor="let plan of COURSE_PLAN_TYPE; let cI = index;
                          "
                          class="col-md-2 text-center position-relative"
                        >
                          <input
                            type="checkbox"
                            [checked]="isCoursePlanSelected(appExam, plan.Code)"
                            (change)="updateCoursePlanSelection(plan, appExam, $event)"
                            [disabled]="checkIfEnabled(plan,appExam)"
                          />
                          <i *ngIf="cI===COURSE_PLAN_TYPE.length-1"  class="fa fa-trash position-absolute end-0 pointer-cursor"
                          (click)=" deleteApplicablecourse(appExam)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </ng-container>
                </ng-container>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class=" btn btn-sm bg-light border "
    (click)="this.onCross()">
    Cancel
  </button>
</div>

